import { UPDATE_USER_INFO_SUCCESS /* , UPDATE_USER_INFO_PROFILE_SUCCESS */ } from '@/constants';

import * as constants from './Identity.constants';
import * as services from './Identity.service';

const state = {
  res_identificationconfig: {
    identificationDesc: '',
  },
  res_certificate: true,
  res_idcheckandsave: {
    checkResult: false,
    checkMessage: '',
  },
  res_idrefuse: {
    checkResult: false,
    checkMessage: '',
  },
  res_idrecall: {
    checkResult: false,
    checkMessage: '',
  },
  isRequest: false,
};

const mutations = {
  [constants.CERTIFICATE_SUCCESS](state, payload) {
    if (undefined !== payload && null !== payload) {
      state.res_certificate = payload;
    }
  },

  [constants.IDENTIFICATION_CONFIG_SUCCESS](state, payload) {
    if (undefined !== payload && null !== payload) {
      state.res_identificationconfig = payload;
    }
  },

  [constants.ID_CHECK_AND_SAVE_SUCCESS](state, payload) {
    if (undefined !== payload && null !== payload) {
      state.res_idcheckandsave = payload;
    }
  },

  [constants.ID_REFUSE_SUCCESS](state, payload) {
    if (undefined !== payload && null !== payload) {
      state.res_idrefuse = payload;
    }
  },

  [constants.ID_RECALL_SUCCESS](state, payload) {
    if (undefined !== payload && null !== payload) {
      state.res_idrecall = payload;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async certificate({ commit }, payload) {
    const res = await services.certificate(payload);
    if (res.data.data) {
      commit(
        UPDATE_USER_INFO_SUCCESS,
        {
          authenticated: 0,
        },
        { root: true }
      );
    }
    commit(constants.CERTIFICATE_SUCCESS, res.data.data);
    return res;
  },

  async identificationconfig({ commit }, payload) {
    //commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.identificationconfig(payload);
    //commit(constants.SET_IS_REQUEST_STATUS, false);
    commit(constants.IDENTIFICATION_CONFIG_SUCCESS, res.data.data);
  },

  async passportsubmit({ dispatch, commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.passportsubmit(payload);
    //if (res.data.data) {
    //  commit(
    //    UPDATE_USER_INFO_PROFILE_SUCCESS,
    //    {
    //      authenticated: 2,
    //    },
    //    { root: true }
    //  );
    //}
    dispatch('getUserInfo', null, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
    commit(constants.ID_CHECK_AND_SAVE_SUCCESS, res.data.data);
  },

  async idcheckandsave({ dispatch, commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.idcheckandsave(payload);
    //if (res.data.data) {
    //  commit(
    //    UPDATE_USER_INFO_PROFILE_SUCCESS,
    //    {
    //      authenticated: 1,
    //    },
    //    { root: true }
    //  );
    //}
    dispatch('getUserInfo', null, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
    commit(constants.ID_CHECK_AND_SAVE_SUCCESS, res.data.data);
  },

  async idrefuse({ dispatch, commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.idrefuse(payload);
    //if (res.data.data) {
    //  commit(
    //    UPDATE_USER_INFO_PROFILE_SUCCESS,
    //    {
    //      identificationStatus: -1,
    //    },
    //    { root: true }
    //  );
    //}
    dispatch('getUserInfo', null, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
    commit(constants.ID_REFUSE_SUCCESS, res.data.data);
  },

  async idrecall({ dispatch, commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.idrecall(payload);
    //if (res.data.data) {
    //  commit(
    //    UPDATE_USER_INFO_PROFILE_SUCCESS,
    //    {
    //      identificationStatus: -2,
    //    },
    //    { root: true }
    //  );
    //}
    dispatch('getUserInfo', null, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
    commit(constants.ID_RECALL_SUCCESS, res.data.data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
